<template>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" :width="$utils.isMobile() ? '80%' : '400px'" :top="$utils.isMobile() ? '40vh' : '30vh'"
        :close-on-click-modal="false" :custom-class="$utils.isMobile() ? 'mobile-dialog' : ''" :show-close="false">
        <div slot="title" v-if="!$utils.isMobile()">{{ title }}</div>
        <!-- 移动端 -->
        <div class="mobile-content" v-if="$utils.isMobile()">
            <div class="prompt"><slot>确定删除“{{ sname }}”吗？</slot></div>
            <div class="btn-wrap">
                <span class="cancel" @click="handleClose">取消</span>
                <span class="confirm" @click="handleConfirm">确定</span>
            </div>
        </div>
        <!-- PC端 -->
        <div class="pc-content" v-else>
            <i class="el-icon-warning"></i>
            <div class="prompt"><slot>确定删除“{{ sname }}”吗？</slot></div>
        </div>
        <!-- 底部按钮 -->
        <span slot="footer" v-if="!$utils.isMobile()">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleConfirm" :loading="loadConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { deleteCustomer, deletePeople } from "@/api/customer/index.js";
import { deleteSchoolContract, deleteDeposit } from "@/api/customer/details.js";
import { deleteSpecialMatter } from "@/api/home/index.js";
import { deleteRequirement } from "@/api/requirement";
export default {
    name: 'delConfirm',
    props: {
        title: {
            default: '删除'
        },
        visible: {
            type: Boolean,
            default: true,
        },
        id: String,
        sname: String,
    },
    watch: {
        visible: {
            handler(val) {
                if (val) {
                    this.dialogVisible = true;
                }
            },
            immediate: true,
        }
    },
    data() {
        return {
            dialogVisible: false,
            loadConfirm: false,
        }
    },
    methods: {
        // 关闭
        handleClose() {
            this.dialogVisible = false;
            this.$emit('update:visible', false);
        },
        // 确认
        handleConfirm() {
            this.loadConfirm = true;
            let reqApi = null;
            let params = {};
            if (this.title === '删除客户') {
                reqApi = deleteCustomer;
                params.sid = this.id;
            } else if (this.title === '删除联系人') {
                reqApi = deletePeople;
                params.id = this.id;
            } else if (this.title === '删除合同') {
                reqApi = deleteSchoolContract;
                params.contractId = this.id;
            } else if (this.title === '删除特殊事项') {
                reqApi = deleteSpecialMatter;
                params.id = this.id;
            } else if (this.title === '删除需求') {
                reqApi = deleteRequirement;
                params.id = this.id;
            } else if (this.title === '删除保证金') {
                reqApi = deleteDeposit;
                params.id = this.id;
            }
            if (!reqApi) return;
            reqApi(params).then(() => {
                this.$MessageBox.MessageSuccess("操作成功");
                this.$emit("change");
                this.handleClose();
                this.loadConfirm = false;
            }).catch((err) => {
                this.$MessageBox.MessageWarning(err.data.msg);
                this.handleClose();
                this.loadConfirm = false;
            });
        },
    }
}
</script>

<style lang="scss">
.mobile-dialog {
    padding: 0;
    border-radius: 10px;
    .el-dialog__body {
        padding: 0;
    }
}
</style>
<style lang="scss" scoped>
.mobile-content {
    padding: 0 1.2rem;
    .prompt {
        color: #333;
        text-align: center;
        line-height: 2;
    }
    .btn-wrap {
        display: flex;
        margin-top: 20px;
        > span {
            width: 50%;
            height: 3.4rem;
            line-height: 3.2rem;
            font-weight: 600;
            font-size: 1.2rem;
            text-align: center;
            border-top: 1px solid #eeeeee;
            &:active {
                background-color: #eeeeee;
            }
        }
        .cancel {
            color: #333;
            border-right: 1px solid #eeeeee;
            border-bottom-left-radius: 10px;
        }
        .confirm {
            color: $primary-btn-color;
            border-bottom-right-radius: 10px;
        }
    }
}

.pc-content {
    text-align: center;
    > i {
        margin-bottom: 15px;
        color: $error-font-color;
        font-size: 48px;
        font-weight: 600;
    }
    .prompt {
        color: #333;
        font-size: 1rem;
    }
}
</style>